import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { AppGlobals } from "../../app.globals";
import { CommonModule } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Subscription } from "rxjs";
import { UserAvatarComponent } from "src/app/components/user-avatar/user-avatar.component";
import { GlobalSearchComponent } from "src/app/components/global-search/global-search.component";
import { NotificationBellComponent } from "src/app/components/notification-bell/notification-bell.component";
import { FeatureFlags } from "src/app/interfaces/enums/feature-flag";

@Component({
    selector: "app-header",
    templateUrl: "./app-header.component.html",
    styleUrls: ["./app-header.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, UserAvatarComponent, GlobalSearchComponent, NotificationBellComponent]
})
export class HeaderComponent implements OnInit, OnDestroy {
  notificationsEnabled = false;

  constructor(public appGlobals: AppGlobals) {}

  ngOnInit(): void {
    this.notificationsEnabled = AppGlobals.UserCan(FeatureFlags.Notifications);
  }

  ngOnDestroy(): void {}
}
